import { useContext, useEffect, useState } from "react";
import { PitchContext } from "../context/PitchContex";
import { IoIosArrowDown } from "react-icons/io";
import { Link } from "react-router-dom";
import PitchItemHorizontal from "../components/PitchItemHorizontal";
import { BsThreeDots } from "react-icons/bs";
import { FaCheck, FaTimes } from "react-icons/fa";
import axios from "axios";

function Profile() {
  const [showInvites, setShowInvites] = useState(false);
  const [userBookings, setUserBookings] = useState([]);
  const [showBookings, setShowBookings] = useState(false);
  const [showPitches, setShowPitches] = useState(false);
  const [showMenu, setShowMenu] = useState(null);
  const [bookingsQuantity, setBookingsQuantity] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const bookingsPerPage = 10;

  const {
    user,
    getUser,
    backendURL,
    token,
    setPending,
    setIsErr,
    setAlertMessage,
    setShowAlert,
  } = useContext(PitchContext);

  const handleInvite = async (process, teamID) => {
    setPending(true);
    try {
      const response = await axios.post(
        backendURL + "team/player-accept-decline",
        { userID: user._id, teamID, process }
      );
      if (response.data.success) {
        setIsErr(false);
        setShowAlert(true);
        setAlertMessage(response.data.message);
      } else {
        setIsErr(true);
        setShowAlert(true);
        setAlertMessage(response.data.message);
      }
      getUser();
      setPending(false);
    } catch (err) {
      setPending(false);
      setIsErr(true);
      setShowAlert(true);
      setAlertMessage(err.response.data.message);
    }
  };

  useEffect(() => {
    return () => {
      localStorage.getItem("isPaid") && localStorage.removeItem("isPaid");
    };
  }, []);

  useEffect(() => {
    if (user && token) {
      setBookingsQuantity(user.bookings.length);
      const temp = user.bookings.slice();
      setUserBookings(
        temp.sort(
          (a, b) =>
            new Date(b.bookingData.dateTime) - new Date(a.bookingData.dateTime)
        )
      );
    }
  }, [user]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getUser();
  }, []);

  const getPhoneVerify = async () => {
    setPending(true);
    try {
      const response = await axios.post(
        backendURL + "user/send-verify-link-phone/" + token,
        { userID: user._id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.data.success) {
        setIsErr(false);
        setShowAlert(true);
        setAlertMessage(response.data.message);
      } else {
        setIsErr(true);
        setShowAlert(true);
        setAlertMessage(response.data.message);
      }
      setPending(false);
    } catch (err) {
      console.log(err);
      setIsErr(true);
      setShowAlert(true);
      setAlertMessage(err.response.data.message);
      setPending(false);
    }
  };

  // Pagination logic
  const totalPages = Math.ceil(userBookings.length / bookingsPerPage);
  const startIndex = (currentPage - 1) * bookingsPerPage;
  const endIndex = startIndex + bookingsPerPage;
  const currentBookings = userBookings.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setShowMenu(null); // Reset menu when changing pages
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="max-w-md w-full bg-white p-8 rounded-3xl shadow-lg border border-gray-200 text-center">
          <div className="flex justify-center items-center mb-6">
            <h1 className="text-4xl font-bold">
              <Link
                className="flex items-center gap-2 group transition-all duration-300"
                to="/"
              >
                <h1 className="text-2xl font-extrabold tracking-tight">
                  H{" "}
                  <span className="text-[#4d9041] group-hover:text-[#62a556]">
                    A
                  </span>{" "}
                  L{" "}
                  <span className="text-[#4d9041] group-hover:text-[#62a556]">
                    I
                  </span>{" "}
                  S{" "}
                  <span className="text-[#4d9041] group-hover:text-[#62a556]">
                    A
                  </span>{" "}
                  H{" "}
                  <span className="text-[#4d9041] group-hover:text-[#62a556]">
                    A
                  </span>{" "}
                  B{" "}
                  <span className="text-[#4d9041] group-hover:text-[#62a556]">
                    U
                  </span>{" "}
                  L
                </h1>
                <img src="/reduced-logo.webp" alt="" className="w-15" />
              </Link>
            </h1>
          </div>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 tracking-tight">
            Profilinizi görmek için giriş yapmalısınız
          </h2>
          <p className="text-gray-600 mb-6 leading-relaxed">
            Üzgünüz, bu sayfaya erişim yetkiniz bulunmamaktadır. Lütfen giriş
            yapmayı deneyin veya ana sayfaya dönün.
          </p>
          <Link to="/giris-yap">
            <button className="w-full bg-[#6ca87e] text-white py-3 px-6 rounded-xl hover:bg-[#5b8f6b] transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 cursor-pointer">
              Giriş Yap
            </button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <section className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="text-center mb-12 animate-fade-in">
        <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900 mb-4 bg-[#4d9041] bg-clip-text text-transparent">
          Profilim
        </h1>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
          Hesap ayrıntılarınızı, rezervasyonlarınızı ve sahalarınızı kolaylıkla
          yönetin
        </p>
      </div>
      <div className="flex flex-col lg:flex-row gap-8">
        <aside className="w-full lg:w-1/3 bg-white p-6 rounded-2xl border border-gray-100 transform hover:scale-[1.02] transition-all duration-300">
          <div className="flex flex-col items-center">
            <div className="relative">
              <img
                src={user.profilePicture}
                alt="Profile"
                className="w-32 h-32 rounded-full object-cover mb-4 border-4 border-[#4d9041] shadow-md"
              />
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              {user.fullname}
            </h2>
            <div className="space-y-2 text-center">
              <p className="text-gray-600 flex items-center justify-center gap-2">
                <span className="text-[#4d9041]">✉️</span> {user.email}
              </p>
              <p className="text-gray-600 flex items-center justify-center gap-2">
                <span className="text-[#4d9041]">📞</span> {user.phone}
              </p>
              <p className="text-gray-600 flex items-center justify-center gap-2">
                <span className="text-[#4d9041]">📍</span> {user.city}
              </p>
            </div>
            <div className="mt-4 bg-gray-50 p-3 rounded-lg w-full">
              <p className="text-gray-600 text-sm">
                Şimdiye kadar{" "}
                <span className="font-bold text-[#4d9041]">
                  {user.bookingQuantity}{" "}
                </span>
                saha rezervasyonu yaptınız
              </p>
              <p className="text-gray-600 text-sm mt-1">
                Katılma tarihi:{" "}
                <span className="text-[#4d9041]">
                  {new Date(user.createdAt).toDateString()}
                </span>
              </p>
            </div>
            <div className="flex flex-wrap justify-center gap-3 mt-6">
              <Link to="/profil-duzenle">
                <button className="px-6 py-2.5 bg-[#4d9041] text-white rounded-lg font-semibold hover:bg-[#62a556] transition-all duration-300 shadow-md hover:shadow-lg cursor-pointer">
                  Profili Düzenle
                </button>
              </Link>
              <Link
                to="/saha-ekle"
                className={`${user.role !== "admin" ? "hidden" : ""}`}
              >
                <button className="px-6 py-2.5 bg-[#4d9041] text-white rounded-lg font-semibold hover:bg-[#62a556] transition-all duration-300 shadow-md hover:shadow-lg cursor-pointer">
                  Saha Ekle
                </button>
              </Link>
              <Link
                to="/odemeler"
                className={`${user.role !== "admin" ? "hidden" : ""}`}
              >
                <button className="px-6 py-2.5 bg-[#4d9041] text-white rounded-lg font-semibold hover:bg-[#62a556] transition-all duration-300 shadow-md hover:shadow-lg cursor-pointer">
                  Ödemelerim
                </button>
              </Link>
            </div>
          </div>
        </aside>
        <main className="w-full lg:w-2/3 space-y-6">
          <div className="bg-white p-6 rounded-2xl shadow-xl border border-gray-100 transform transition-all duration-300">
            <div
              className="flex items-center justify-between cursor-pointer p-2 rounded-lg"
              onClick={() => {
                setShowBookings((prev) => !prev);
                setShowMenu(null);
              }}
            >
              <h3 className="text-xl font-bold text-gray-800">
                Rezervasyonlarım ({bookingsQuantity})
              </h3>
              <IoIosArrowDown
                className={`text-[#4d9041] w-6 h-6 transition-transform duration-300 ${
                  showBookings ? "rotate-180" : ""
                }`}
              />
            </div>
            {showBookings && (
              <div className="mt-4 space-y-4 animate-fade-in">
                {currentBookings.length > 0 ? (
                  currentBookings.map((pitch, index) => {
                    const date = new Date(pitch.bookingData?.dateTime);
                    return (
                      <div
                        key={index}
                        className="flex justify-between items-center p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-all duration-200 relative"
                      >
                        <Link
                          to={`/sahalar/${pitch.pitchID.slug}`}
                          className="text-[12px] sm:text-lg text-[#4d9041] font-semibold hover:text-[#62a556] transition-colors duration-200"
                        >
                          {pitch.pitchID.name}
                        </Link>
                        <div className="flex gap-1">
                          <div className="text-right space-y-1">
                            <div className="flex gap-1 text-gray-700">
                              <p className="text-[10px] sm:text-sm font-medium">
                                {date.toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })}
                              </p>
                              <p className="text-[10px] sm:text-sm font-medium">
                                {pitch.bookingData?.time}
                              </p>
                            </div>
                            <p className="text-[10px] sm:text-sm text-gray-600">
                              📞 {pitch.pitchID.ownerID.phone}
                            </p>
                            <div className="flex justify-end items-center gap-2">
                              <span
                                className={`text-[10px] sm:text-xs font-medium px-2 py-1 rounded-full ${
                                  pitch.paymentStatus !== "unpaid"
                                    ? "bg-green-100 text-green-700"
                                    : "bg-gray-100 text-gray-700"
                                }`}
                              >
                                {pitch.paymentStatus !== "unpaid"
                                  ? "Ödendi"
                                  : "Ödenmedi"}
                              </span>
                              <span
                                className={`text-[10px] sm:text-xs font-medium px-2 py-1 rounded-full ${
                                  date > new Date()
                                    ? "bg-green-100 text-green-700"
                                    : "bg-gray-100 text-gray-700"
                                }`}
                              >
                                {date > new Date() ? "Gelecek" : "Geçmiş"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center py-6">
                    <p className="text-gray-600 mb-4">Henüz rezervasyon yok</p>
                    <Link to="/sahalar">
                      <button className="bg-[#4d9041] text-white py-2 px-6 rounded-lg font-semibold hover:bg-[#62a556] transition-all duration-300 shadow-md">
                        Rezervasyon Yap
                      </button>
                    </Link>
                  </div>
                )}
                {totalPages > 1 && (
                  <div className="flex justify-center items-center gap-2 mt-4">
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      className={`px-4 py-2 rounded-lg font-semibold transition-all duration-300 ${
                        currentPage === 1
                          ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                          : "bg-[#4d9041] text-white hover:bg-[#62a556]"
                      }`}
                    >
                      Önceki
                    </button>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                      (page) => (
                        <button
                          key={page}
                          onClick={() => handlePageChange(page)}
                          className={`px-3 py-1 rounded-lg font-semibold transition-all duration-300 ${
                            currentPage === page
                              ? "bg-[#4d9041] text-white"
                              : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                          }`}
                        >
                          {page}
                        </button>
                      )
                    )}
                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      className={`px-4 py-2 rounded-lg font-semibold transition-all duration-300 ${
                        currentPage === totalPages
                          ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                          : "bg-[#4d9041] text-white hover:bg-[#62a556]"
                      }`}
                    >
                      Sonraki
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
          {(user.role === "admin" || user.pitches.length > 0) && (
            <div className="bg-white p-6 rounded-2xl shadow-xl border border-gray-100 transform transition-all duration-300">
              <div
                className="flex items-center justify-between cursor-pointer p-2 rounded-lg"
                onClick={() => setShowPitches((prev) => !prev)}
              >
                <h3 className="text-xl font-bold text-gray-800">
                  Sahalarım ({user.pitches.length})
                </h3>
                <IoIosArrowDown
                  className={`text-[#4d9041] w-6 h-6 transition-transform duration-300 ${
                    showPitches ? "rotate-180" : ""
                  }`}
                />
              </div>
              {showPitches && (
                <div className="mt-4 space-y-4 animate-fade-in">
                  {user.pitches.length > 0 ? (
                    user.pitches.map((pitch) => (
                      <PitchItemHorizontal
                        key={pitch._id}
                        id={pitch._id}
                        slug={pitch.slug}
                        name={pitch.name}
                        location={`${pitch.location.city}`}
                        price={pitch.price}
                        status={pitch.status}
                        showBookingsButton={true}
                      />
                    ))
                  ) : (
                    <div className="text-center py-6">
                      <p className="text-gray-600 mb-4">
                        Henüz saha eklemediniz
                      </p>
                      <Link to="/saha-ekle">
                        <button className="bg-[#4d9041] text-white py-2 px-6 rounded-lg font-semibold hover:bg-[#62a556] transition-all duration-300 shadow-md cursor-pointer">
                          Saha ekle
                        </button>
                      </Link>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          {user.teamRequest?.teamId?.length > 0 && (
            <div className="bg-white p-6 rounded-2xl shadow-xl border border-gray-100 transform transition-all duration-300">
              <div
                className="flex items-center justify-between cursor-pointer p-2 rounded-lg"
                onClick={() => setShowInvites((prev) => !prev)}
              >
                <h3 className="text-xl font-bold text-gray-800">
                  Takım Davetleri ({user.teamRequest.teamId.length})
                </h3>
                <IoIosArrowDown
                  className={`text-[#4d9041] w-6 h-6 transition-transform duration-300 ${
                    showInvites ? "rotate-180" : ""
                  }`}
                />
              </div>
              {showInvites && (
                <div className="mt-4 space-y-4 animate-fade-in">
                  {user.teamRequest.teamId.map((invite) => {
                    const date = new Date(invite.createdAt);
                    return (
                      <div
                        key={invite._id}
                        className="p-4 bg-gray-50 rounded-xl border hover:bg-gray-100 transition-all duration-200 relative"
                      >
                        <p className="text-gray-800 font-medium">
                          {invite.name} sizi takıma davet etti.
                        </p>
                        <div className="flex justify-between items-center mt-2 text-sm">
                          <span className="text-gray-500">
                            {date.toLocaleDateString("tr-TR")}
                          </span>
                        </div>
                        <div className="absolute bottom-4 right-4 flex space-x-2">
                          <button
                            onClick={() => handleInvite("accept", invite._id)}
                            className="bg-[#4d9041] hover:bg-[#62a556] text-white p-2 rounded-full cursor-pointer"
                          >
                            <FaCheck />
                          </button>
                          <button
                            onClick={() => handleInvite("decline", invite._id)}
                            className="bg-red-500 hover:bg-red-600 text-white p-2 rounded-full cursor-pointer"
                            name="decline"
                          >
                            <FaTimes />
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </main>
      </div>
      {/* {!user.phoneVerified && (
        <div className="mt-10 bg-yellow-50 border border-yellow-300 text-yellow-800 px-6 py-4 rounded-2xl mb-6 flex justify-between items-center animate-fade-in">
          <p className="text-sm sm:text-base">
            Henüz telefonunuzu doğrulamadınız. SMS yolu ile bildirim almak için
            lütfen numaranızı doğrulayınız.
          </p>
          <button
            onClick={getPhoneVerify}
            className="ml-4 px-5 py-2 bg-[#4d9041] text-white rounded-lg font-semibold hover:bg-[#62a556] transition-all duration-300 cursor-pointer"
          >
            Doğrula
          </button>
        </div>
      )} */}
    </section>
  );
}

export default Profile;
